export default __webpack_public_path__ + "032132e773a17a50eac707b5457ff864.png";